export default "__VITE_ASSET__6b4e0353__"